<template>
  <div class="control">
    <div class="control__title">
      <div class="title">
        <div class="title-text">
          {{ title }}
        </div>
        <div class="control__helper">
          <div
            class="control__trigger"
            @mouseover="showHint = true"
            @mouseleave="showHint = false"
          >
            <img
              src="https://sirv.sirv.com/website/theme2/icon/question.svg"
              :alt="hint"
            >
          </div>
          <div
            v-show="showHint"
            class="hint"
          >
            {{ hint }}
          </div>
        </div>
      </div>
    </div>
    <div class="control__action">
      <div class="control__choice">
        <div
          class="fakeoverlay"
          :class="{disabled: !radioStatus}"
          @click="radioStatus =! radioStatus"
        />
        <el-checkbox
          :disabled="!radioStatus"
          v-model="value"
          :label="radioOption[0].value"
          :style="{width: '100%'}"  
          @change="handleAllOptions"
        > 
          {{ radioOption[0].label }}
        </el-checkbox>
        <el-checkbox-group v-model="value">
          <el-checkbox
            v-for="(radioValue, index) in radioOption.slice(1)"
            :key="index"
            :disabled="!radioStatus"
            :label="radioValue.value"
            @change="handleOptionalConfig"
            :style="{width: '100%'}"
          >
            {{ radioValue.label }}
          </el-checkbox>
        </el-checkbox-group>
      </div>
      <el-checkbox
        v-model="radioStatus"
        class="control__checkbox"
        @change="changeOption"
      />
    </div>
    <div :style="{marginLeft: '15px'}">
      <strong>File size:</strong> <span v-html="sizeDefault"></span>
    </div>
  </div>
</template>
<script>  
import { mapState } from 'vuex'
import { scriptSelectiveKey } from '@/utils/script-utils'
import { loadSirv } from '@/utils/load-sirv'
import { loadScriptSize } from '@/utils/load-sript-size'


const dataScriptSize = `134.06 KB <i>(unzipped 513.39 KB)</i>`

export default {
  name: 'CheckboxLoadSirv',
  props: {
    title: {
      type: String,
      default: ''
    },
    default: {
      type: Array,
      default: () => []
    },
    hint: {
      type: String,
      default: ''
    },
    status: {
      type: Boolean
    },
    options: {
      type: Array,
      default: Function
    },
    parameter: {
      type: String,
      default: ''
    },
    eventClick: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      value: this.default,
      radioStatus: this.status,
      radioOption: this.options,
      showHint: false,
      sizeDefault: dataScriptSize
    }
  },
  computed: {
    ...mapState([
      'clearOptions',
    ]),
    selectedAllOptions(){
      return this.value.length === this.radioOption.length - 1
    },

    normalizedValue(){
      return this.selectedAllOptions ? [] : this.value.filter(Boolean)  
    }

  },
  watch: {
    clearOptions(value) {
      if (value) {
        this.radioStatus = false
        this.value = this.default
      }
    },
    eventClick(val) {
      this.value = this.default
      this.radioStatus = val
    },
    radioStatus(val) {
        this.changeOption()
    },
  },
  methods: {

    handleAllOptions(){
      this.value = ['']
      this.changeOption()
    },

    handleOptionalConfig(){
      this.value = this.value.filter(Boolean)
      this.changeOption()
    },

    scriptSizeResolveHandler( err = null, data = null ){
      if( err || ! data.size ) this.sizeDefault = dataScriptSize
      this.sizeDefault = data.size
    },

    handleSriptSize(){
      if( ! this.normalizedValue.length ) return this.sizeDefault = dataScriptSize
      loadScriptSize( this.normalizedValue,  this.scriptSizeResolveHandler)
    },

    changeOption(){
      const value = this.radioStatus && this.normalizedValue.length ? this.value : []
      const scriptType = this.radioStatus && this.normalizedValue.length ? scriptSelectiveKey : ''
      this.$store.dispatch('script/setScriptType', { scriptType, scriptComponents: value })
      loadSirv( this.normalizedValue.length ? this.value.join(',') : '' )
      this.handleSriptSize()
    }

  }
}
</script>
